import * as React from "react";
const SvgMountingPlate = (props) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 17.65 21.18",
	width: "1em",
	height: "1em",
	...props
}, /* @__PURE__ */ React.createElement("defs", null), /* @__PURE__ */ React.createElement("g", {
	id: "mounting_plate_svg__Layer_2",
	"data-name": "Layer 2"
}, /* @__PURE__ */ React.createElement("g", {
	id: "mounting_plate_svg__Layer_1-2",
	"data-name": "Layer 1"
}, /* @__PURE__ */ React.createElement("path", {
	d: "M0 20.21v-8.64a1 1 0 0 1 .76-1L15.7 7.26V1a1 1 0 0 1 1-1 1 1 0 0 1 1 1v6.36a1.82 1.82 0 0 1-1.43 1.78L2 12.35v6.88h4.28v-2.95a1 1 0 1 1 2 0v3.93a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1",
	style: { fill: "currentColor" }
}), /* @__PURE__ */ React.createElement("path", {
	d: "M4.14 17.65a1 1 0 0 1-1-1v-2a1.9 1.9 0 0 1 1.46-1.84l6.65-1.63h4.27a1 1 0 0 1 1 1 1 1 0 0 1-1 1h-4.18l-6.23 1.51v2a1 1 0 0 1-.97.96",
	style: { fill: "currentColor" }
}))));
export default SvgMountingPlate;
